import React from "react"
import RequestMailPage from './RequestMailPage'
import ResetPasswordPage from './ResetPasswordPage'
import {RouteComponentProps} from "react-router"
import "./styles.scss"


type Params = {
	token: string,
	stage: string
}

export const ResetRoot: React.FC<RouteComponentProps<Params>> = ({match: {params: {token, stage}}}: RouteComponentProps<Params>) => {
	if (token) {
		return <ResetPasswordPage {...{token, stage}} />
	} else {
		return <RequestMailPage {...{token, stage}} />
	}
}

export default ResetRoot